import React, {FC, useEffect, useState} from 'react'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import Select from 'react-select'
import {fetchData, hasSpecialCharacters, toasterrormsg, toastsuccessmsg} from '../../../reusable'
import {ToastContainer} from 'react-toastify'

interface PaymentDetailsHeaderProps {
  bookingId: string // Assuming bookingId is of type string, adjust as needed
  bookingdetailId: string // Assuming bookingId is of type string, adjust as needed
}

const PaymentDetail: React.FC<PaymentDetailsHeaderProps> = ({bookingId, bookingdetailId}) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [price, setPrice] = useState('')
  const [coupondiscount, setCouponDiscount] = useState('')
  const [discount, setDiscount] = useState('')
  const [extraPeopleCharge, setExtraPeopleCharge] = useState('')
  const [userPoints, setUserPoints] = useState('')
  const [totalAmount, setTotalAmount] = useState('')

  const BookingListApiCall = async () => {
    var param: any = {
      bookingId: bookingId,
      categoryId: '4',
    }

    var res = await fetchData('admin/bookingdetail', param)

    if (res.status == '200') {
      var data = res.data
      data.map((items: any) => {
        var bookingDetail = items.bookingDetail.filter(
          (item: any) => item.bookingdetailId == bookingdetailId
        )
        setDiscount(bookingDetail[0].discount )
        setExtraPeopleCharge(bookingDetail[0].extraPeopleCharge)
        setPrice(bookingDetail[0].price)
        setUserPoints(bookingDetail[0].userpoints  != ""  ? bookingDetail[0].userPoints  : "")

      })
   
      setCouponDiscount(data[0].coupondiscount)
    } else {
    }
  }
  const [error, setError] = useState([
    {
      
      price: '',
      coupondiscount: '',
      discount : "",
      extraPeopleCharge : "",
      userPoints : "",
    },
  ])

  useEffect(() => {
    BookingListApiCall()
  }, [])

  const editBookingDetails = async () => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }
    var param: any = {
      bookingId: bookingId,
      adminId: adminId,
      price: String(price),
    }

    var res = await fetchData('admin/editrentablespacebooking', param)
    if (res.status == '200') {
      setDisable(false)
      setLoading(false)
      toastsuccessmsg('Updated Successfully')
    } else {
    }
  }

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {bookingId != '' ? 'Edit Booking Details' : 'Add Basic Information'}
      </PageTitle>
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>Payment Details</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                      </div>

                      <div className='card-body pt-0'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>Price</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='price'
                              className='form-control mb-2'
                              placeholder='Price'
                              value={price}
                              onChange={(e) => {
                                setPrice(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].price}</div>
                          </div>
                          
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>Extra People Charge</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='extraPeopleCharge'
                              className='form-control mb-2'
                              placeholder='Extra Prople Charge'
                              value={extraPeopleCharge}
                              onChange={(e) => {
                                setExtraPeopleCharge(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].extraPeopleCharge}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>Coupon Discount</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='coupondiscount'
                              className='form-control mb-2'
                              placeholder='Coupon Discount'
                              value={coupondiscount}
                              onChange={(e) => {
                                setCouponDiscount(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].coupondiscount}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>User Point</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='userpoint'
                              className='form-control mb-2'
                              placeholder='User Points'
                              value={userPoints}
                              onChange={(e) => {
                                setUserPoints(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].userPoints}</div>
                          </div>
                          
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>Discount</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='Discount'
                              className='form-control mb-2'
                              placeholder='Discount'
                              value={discount}
                              onChange={(e) => {
                                setDiscount(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].discount}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>Original Amount</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='Discount'
                              className='form-control mb-2'
                              placeholder='Discount'
                              value={discount}
                              onChange={(e) => {
                                setDiscount(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].discount}</div>
                          </div>
                          
                        
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>

                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <Link
                  to='../viewbookinghotels/'
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                >
                  Cancel
                </Link>

                <button type='button' disabled={disable} className='btn btn-primary'>
                  <span
                    className='indicator-label'
                    onClick={() => {
                      setDisable(true)
                      setLoading(true)
                      editBookingDetails()
                    }}
                  >
                    Save
                  </span>

                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export {PaymentDetail}
